import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { pure } from 'recompose'
import ControlledExpandableItem from './controlled-expandable-item'

const propTypes = {
  children: PropTypes.node.isRequired,
  startExpanded: PropTypes.bool,
  expandTriggerable: PropTypes.bool,
}

const defaultProps = {
  startExpanded: false,
}

function ExpandableItem({
  children,
  startExpanded,
  expandTriggerable = false,
  ...rest
}) {
  const [expanded, setExpanded] = useState(startExpanded)

  // Sync internal state when startExpanded prop changes
  useEffect(() => {
    expandTriggerable && setExpanded(startExpanded)
  }, [startExpanded])

  return (
    <ControlledExpandableItem
      expanded={expanded}
      setExpanded={setExpanded}
      {...rest}
    >
      {children}
    </ControlledExpandableItem>
  )
}

ExpandableItem.propTypes = propTypes
ExpandableItem.defaultProps = defaultProps

export default pure(ExpandableItem)
